export default {"src":"/_next/static/media/process_optimization_and_automation.7954e821.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};